import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Este PDF sirve solo para gerentes?',
  answer: 'No. Aunque está pensado para roles corporativos, gerenciales y de liderazgo, el método aplica para cualquier entrevista profesional donde quieras destacar.'
}, {
  question: '¿Qué tan rápido puedo aplicarlo?',
  answer: 'Puedes leerlo hoy y aplicarlo en tu próxima entrevista. Es práctico desde la primera página.'
}, {
  question: '¿Necesito mucha experiencia para que funcione?',
  answer: 'No. El método funciona tanto si tienes años de trayectoria como si estás dando un siguiente paso importante en tu carrera.'
}, {
  question: '¿El contenido es práctico o solo teórico?',
  answer: '100% práctico. Incluye un banco de preguntas listas para usar y un método claro para aplicar en entrevistas reales.'
}, {
  question: '¿Lo puedo leer en celular o laptop?',
  answer: 'Sí. Es un PDF que puedes leer desde cualquier dispositivo y consultar antes de cada entrevista.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 lg:py-24 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-47">
      <FadeIn data-id="element-48">
        <h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-12 text-center tracking-tight" data-id="element-49">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-50">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`border rounded-xl overflow-hidden transition-colors ${isOpen ? 'border-emerald/50 bg-white' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-51">
                <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-52">
                  <span className="font-bold text-navy text-lg pr-4" data-id="element-53">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-emerald' : ''}`} data-id="element-54" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-55">
                  <p className="text-gray-600" data-id="element-56">{faq.answer}</p>
                </div>
              </div>;
        })}
        </div>
      </FadeIn>
    </section>;
}